module.exports = __webpack_public_path__ + "img/MO.c526d4cc.svg";